export enum MultiValueFilterOperation {
   Between = 'Between',
   In = 'In',
   NotIn = 'NotIn',
}
